import { useRef, useCallback, useContext, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { useError, useNavLinks } from ".";
import { MainContext } from "../context/main";
import { fetchGet } from "../utils";

export default function useCurrentPost(
  { initialize = true } = { initialize: true }
) {
  const location = useLocation();
  const { id } = useParams();
  const { mainStore, mainDispatch } = useContext(MainContext);
  const { setError } = useError();
  const { updateNavButtons } = useNavLinks();
  const isFetching = useRef(false);

  const fetchData = async ({ showEditButton }) => {
    if (!initialize) {
      return;
    }
    const params = new URLSearchParams({ id });
    const url =
      id && id.length > 0
        ? `/api/wiki/?` + params.toString()
        : `/api/wiki${location.pathname}`;

    if (isFetching.current) {
      return;
    }
    isFetching.current = true;
    const { body, error } = await fetchGet({
      url,
    });
    if (error) {
      setError(error);
    }

    if (body) {
      mainDispatch({
        type: "MAIN_SET_CURRENT_POST",
        currentPost: body,
      });
      updateNavButtons({ nextCurrentPost: body, showEditButton });
    }
    isFetching.current = false;
  };

  useEffect(() => {
    const isNew = location.pathname.substring(0, 4) === "/new";
    if (isNew) {
      return;
    }
    const currentPostId =
      mainStore && mainStore.currentPost ? mainStore.currentPost.id : null;

    if (!currentPostId) {
      fetchData({});
      return;
    }

    const currentPostPath =
      mainStore && mainStore.currentPost ? mainStore.currentPost.path : null;

    //const usePath =
    //location.pathname.substring(0, 5) !== "/edit" &&
    //location.pathname.substring(0, 7) !== "/public";

    const pathMatches = currentPostPath === location.pathname;

    const idMatches = id && id === currentPostId;

    if (idMatches || pathMatches) {
      return;
    }

    fetchData({});
    return () => {
      mainDispatch({
        type: "MAIN_SET_NAV_BUTTONS",
        navButtons: [],
      });
      mainDispatch({
        type: "MAIN_SET_CURRENT_POST",
        currentPost: null,
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, mainStore.currentPost, id]);

  const updatePost = useCallback((updates) => {
    mainDispatch({ type: "MAIN_UPDATE_CURRENT_POST", currentPost: updates });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    hideDelete: mainStore.currentPost
      ? mainStore.currentPost.path === "/home"
      : false,
    title: mainStore.currentPost ? mainStore.currentPost.title : "",
    isPublic: mainStore.currentPost ? mainStore.currentPost.isPublic : false,
    content: mainStore.currentPost ? mainStore.currentPost.htmlContent : "",
    path: mainStore.currentPost ? mainStore.currentPost.path : "",
    rawContent: mainStore.currentPost ? mainStore.currentPost.mdContent : "",
    currentPost: mainStore.currentPost || {},
    fetchData,
    updatePost,
    updateNavButtons,
  };
}
